<template>
  <div>
    <v-data-table :headers="headers" :items="disciplines" sort-by="Id" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px" v-if="canManageCurrentFederation">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">Créer une Discipline</v-btn>
            </template>
            <v-card>
              <v-card-text>
                <v-form ref="disciplineForm">
                  <v-container>
                    <v-row>
                      <!--Partie de saisie du dialog-->
                      <v-col cols="12" sm="6" md="12">
                        <v-text-field v-model="editedItem.name" label="Nom" :rules="[rules.required, rules.counter]" counter maxlength="60"></v-text-field>
                      </v-col>
                      <v-col></v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDialog">Annuler</v-btn>
                <v-btn color="blue darken-1" text @click="submitForm(editedItem)">{{ isEditing ? "Modifier" : "Créer" }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon class="mr-2" @click="navigateToDiscipline(item)" title="Ouvrir la discipline">mdi-open-in-app</v-icon>
        <v-icon class="mr-2" @click="openDisciplineDialog(item)" title="Editer" v-if="canManageCurrentFederation">edit</v-icon>
        <v-icon @click="deleteDiscipline(item)" v-if="canManageCurrentFederation">delete</v-icon>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { deleteDisciplineAsync, createDisciplineAsync, updateDisciplineAsync, getDisciplinesByFederationIdAsync } from "@/api/disciplinesApi";
import { getIsUserPartOfFederationAsync } from "../../api/federationsApi";
import { VDataTable } from "vuetify/lib";
import store from "@/store";
import PermissionsService from "@/services/PermissionsService";
import AuthService from "@/services/AuthService";

export default {
  components: {
    VDataTable,
  },

  props: {
    federationId_prop: Number,
  },

  data: () => ({
    authService: AuthService,
    isCurrentUserPartOfFederation: false,
    federationId: null,
    dialog: false,
    headers: [
      // { text: "Id", value: "id", sortable: true },
      { text: "Nom de la discipline", value: "name", sortable: true },
      { text: "Nombre de gestionnaires", value: "disciplineManagers.length", sortable: true },
      { text: "Nombre d'entraîneurs", value: "disciplineCoaches.length", sortable: true },
      { text: "Actions", value: "action", sortable: false },
    ],
    isEditing: false,
    disciplines: [],
    editedItem: {},
    rules: {
      required: (value) => !!value || "Requis.",
      counter: (value) => (value ? value.length <= 60 : "Max 60 caractères"),
    },
  }),

  watch: {
    $route() {
      this.initPage();
    },
    dialog(val) {
      val || this.closeDialog();
    },
  },

  computed: {
    canViewCurrentFederation() {
      // Can view own federation and is part of current federation
      let canViewOwnFederationAndIsPartToCurrentFederation = PermissionsService.FederationsPermissionsService.canViewOwnFederation && this.isCurrentUserPartOfFederation;
      // Can view all federations
      let canViewAllFederations = PermissionsService.FederationsPermissionsService.canViewAllFederations;
      return canViewOwnFederationAndIsPartToCurrentFederation || canViewAllFederations;
    },
    canManageCurrentFederation() {
      // Can manage own federation and is part of current federation
      let canManageCurrentFederationAndIsPartToCurrentFederation =
        PermissionsService.FederationsPermissionsService.canManageOwnFederation && this.isCurrentUserPartOfFederation;
      // Can manage all federations
      let canManageAllFederations = PermissionsService.FederationsPermissionsService.canManageAllFederations;
      return canManageCurrentFederationAndIsPartToCurrentFederation || canManageAllFederations;
    },
  },

  async mounted() {
    await this.initPage();
  },

  methods: {
    async initPage() {
      // Override the props values from the url if provided
      this.federationId = this.$route.params.federationId ? parseInt(this.$route.params.federationId) : this.federationId_prop;

      // Check if the current user is part of current federation
      this.isCurrentUserPartOfFederation = await getIsUserPartOfFederationAsync(this.authService.userId, this.federationId);

      // Check if the user can see this page
      if (!this.canViewCurrentFederation) {
      store.dispatch("setSnackbar", {
        title: `Non Autorisé`,
        text: `Vous n'êtes pas autorisé à consulter cette ressource.`,
        status: "warning",
        timeout: 2000,
      });

      this.$router.replace("/");
      }

      // Get the list of federation's disciplines
      this.initializeList();
    },

    // Get the list of federation's disciplines
    async initializeList() {
      this.disciplines = await getDisciplinesByFederationIdAsync(this.federationId);
    },

    // navigate to the discipline panel
    navigateToDiscipline(item) {
      this.$router.push({
        name: "DisciplinePanel",
        params: {
          federationId: this.federationId,
          disciplineId: item.id,
          tab: "teams",
        },
      });
    },

    // CREATE or UPDATE a discipline
    async submitForm(discipline) {
      // Validate the form
      var isFormValid = this.$refs.disciplineForm.validate();

      // If the form is valid
      if (isFormValid) {
        var result = !this.isEditing ? await createDisciplineAsync(this.federationId, discipline) : await updateDisciplineAsync(discipline.id, discipline);

        // If we have an id > 0 in the result, the save succeeded
        if (result && result.id > 0) {
          var createdOrUpdatedMessage = !this.isEditing ? "créée" : "mise à jour";

          store.dispatch("setSnackbar", {
            title: `Discipline ${createdOrUpdatedMessage}`,
            text: `La discipline a bien été ${createdOrUpdatedMessage}.`,
            status: "success",
            timeout: 2000,
          });

          this.editedItem = {};
          this.$refs.disciplineForm.reset();
          this.isEditing = false;
        }

        this.closeDialog();

        await this.initializeList();
      }
      // Else display the error messages
      else {
        // Handle missing name
        if (!discipline.name) {
          store.dispatch("setSnackbar", {
            title: "Nom requis",
            text: "Veuillez renseigner le nom.",
            status: "error",
            timeout: 2000,
          });
        }
      }
    },

    editDiscipline(item) {
      this.editedItem = item;
      this.isEditing = true;
      this.dialog = true;
    },

    // Delete a Discipline
    async deleteDiscipline(item) {
      if (confirm("Etes-vous sûr de vouloir supprimer cette discipline ?")) {
        var result = await deleteDisciplineAsync(item.id);

        if (result) {
          store.dispatch("setSnackbar", {
            title: "Discipline supprimée",
            text: "La discipline a bien été supprimée.",
            status: "success",
            timeout: 2000,
          });
        }

        await this.initializeList();
      }
    },

    // Open the discipline dialog
    openDisciplineDialog(item = null) {
      // If we are in edit mode
      if (item) {
        this.editedItem = item;
        this.isEditing = true;
      } else {
        this.isEditing = false;
      }
      this.dialog = true;
    },

    // Close the discipline dialog
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>
